import { createFileRoute } from '@tanstack/react-router';

// Scaffold — create-organization flow (full implementation in a follow-up task).
export const Route = createFileRoute('/_authenticated/tenants/new')({
  component: NewTenantPage,
});

function NewTenantPage() {
  return <div className="p-8">New Tenant</div>;
}
